export const RadioUnselectedIcon = ({ color = "#F9EDD3", size = 15, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="7.5" cy="7.5" r="6.5" stroke={color} strokeWidth="2" />
    </svg>
);
